import { Component, Inject, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { MatDialog,  } from '@angular/material/dialog';
import { ActivatedRoute, Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { Clipboard } from '@angular/cdk/clipboard';
import { PublishAppService } from '../publish-app.service';
import { APIConfigMapping, HTTPAPIConfig, ImageCropperComponent, VlDataService, VlHttpService,ENV_CONFIG,Environment, APP_BUILDER_PERMISSIONS, PERMISSIONS_ACTIONS } from 'shared-library';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'lib-publish-app',
  templateUrl: './publish-app.component.html',
  styleUrls: ['./publish-app.component.scss']
})
export class PublishAppComponent implements OnInit,OnDestroy{

  applicationDetails!:FormGroup;
  certificateDetails!:FormGroup;
  mobileApplicationData = JSON.parse(localStorage.getItem('mobileMeta') as string);
  versionList!:any;
  selectedImage!:File;
  showDetails:boolean = false;


  statusMessage: { [key: string]: string } = {
    "created": "Application Created Successfully!",
    "updated": "Application updated . Kindly use a existing apk.",
    "failed": "Something went wrong , you can try again Later. Until then, here is your old build APK."
  }

  publishStatus:boolean = false;
  spinnerActive:boolean = false;
  isDownloadApkAvailable: boolean = false;
  downLoadURL!: string;
  isPublished: boolean = false;
  flutterConfig:any;
  queryParams: {
    [key: string]: string;
  } = {};
  apkStatus!:string;
  imageSrc = './assets/images/app-icon-placeholder.png';

  environment:Environment;

  fetchingAPKDetails: boolean = false;
  isErrorWhileAPKFetching: boolean = false;
  errorMessage='';
  fetchingDetails:boolean=false;
  subscriptions: Subscription[] = [];
  destroy$:Subject<void> = new Subject<void>;

  appPermissions = APP_BUILDER_PERMISSIONS;
    permissionsActions = PERMISSIONS_ACTIONS;
  
  constructor(public dialog: MatDialog, private dataService: VlDataService,private _fb:FormBuilder,
    private httpService: VlHttpService,private route: ActivatedRoute,private toasterService:ToastrService,
    private clipboard: Clipboard, private publishService : PublishAppService,    private http: HttpClient,
    @Inject(ENV_CONFIG) private ENV: any,){
      this.environment = ENV;
  }

  ngOnInit(): void {
    this.formBuilder();
    this.subscribeRouterEvents();
    this.viewSetter();
    this.spinnerActive=true;
    this.checkPublishStatus();
    // this.publishService.getAPKDetails().subscribe((res: any) => {
    //   this.errorMessage=this.statusMessage[res?.data?.apk_status];  
    //   this.apkStatus = res?.data?.apk_status;
    //   this.flutterConfig=res?.data?.flutter_config;
    //   if (res?.data && !res?.data?.is_published) {
    //     this.apkStatus = res?.data?.apk_status;
    //     this.fetchingAPKDetails = false;
    //     this.downLoadURL = res?.data?.apk_url ?? '';
    //     this.errorMessage = this.statusMessage[this.apkStatus]
    //     this.publishService.stopApiCalls(res?.data)
    // }
    //   else {
    //     this.downLoadURL = "";
    //     this.fetchingAPKDetails = true;
    //     this.publishService.startApiCalls();
    //   }
    // },
    // (error: any) => {
    //   this.fetchingAPKDetails = false;
    //   this.publishService.startApiCalls();
    // })
    this.publishService.actionCompleted$.pipe(takeUntil(this.destroy$)).subscribe((value:any) => {
      this.apkStatus = value?.apk_status;
      this.fetchingAPKDetails = false;
      this.downLoadURL = value?.apk_url ?? '';
      this.errorMessage = this.statusMessage[this.apkStatus];
    })
  }

  formBuilder(){
     this.applicationDetails = this._fb.group({
        applicationName: ['', Validators.required],
        playstoreApplicationId: ['', [Validators.required,this.customFormatValidator()]],
        applicationVersion: ['', [Validators.required,this.numberFormatValidator()]],
        image: [''],
      }),
      this.certificateDetails = this._fb.group({
        firstAndLastName: ['', Validators.required],
        organizationalUnit: ['', Validators.required],
        organization: ['', Validators.required],
        cityOrLocality: ['', Validators.required],
        stateOrProvince: ['', Validators.required],
        countryCode: ['', Validators.required]
      })
  }

  subscribeRouterEvents(){
    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((params: Params) => {
      this.queryParams = {};
      for (const param in params) {
        if (params.hasOwnProperty(param)) {
          this.queryParams[param] = params[param];
        }
      }
    });
  }

  customFormatValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      const inputValue: string = control.value;
      const regexPattern: RegExp =/^[a-zA-Z][a-zA-Z0-9_]*(\.[a-zA-Z][a-zA-Z0-9_]*)+$/;
  
      if (regexPattern.test(inputValue)) {
        return null; // Valid input
      } else {
        return { 'invalidFormat': { value: inputValue } }; // Invalid input
      }
    };
  }

  numberFormatValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      const inputValue: string = control.value;
      const regexPattern: RegExp = /^[0-9]+(\.[0-9]+){2}$/;
  
      if (regexPattern.test(inputValue)) {
        return null; // Valid input
      } else {
        return { 'invalidFormat': { value: inputValue } }; // Invalid input
      }
    };
  }


   async viewSetter(){
    this.versionList = await this.publishService.getVersionHistoryList().toPromise();
    if(this.versionList.length === 0){
      this.imageSrc = this.mobileApplicationData.image;
      let imageFile = await this.getDefaultAppLogo(this.imageSrc)
      this.applicationDetails.patchValue({
        applicationName:this.mobileApplicationData.mobileApplicationName,
        image:imageFile
      })
    }else{
      let latestpublish:any = this.versionList[0];
      this.applicationDetails.patchValue({
        applicationName:latestpublish.applicationName,
        playstoreApplicationId: latestpublish.playstoreApplicationId,
        applicationVersion: latestpublish.applicationVersion,
        image: latestpublish.image,
      })
      this.certificateDetails.patchValue({
        firstAndLastName:latestpublish.firstAndLastName ,
        organizationalUnit:latestpublish.organizationalUnit,
        organization: latestpublish.organization,
        cityOrLocality: latestpublish.cityOrLocality,
        stateOrProvince: latestpublish.stateOrProvince,
        countryCode: latestpublish.countryCode
      })
      this.showDetails=true;
      this.applicationDetails.get('playstoreApplicationId')?.disable();
      this.certificateDetails.disable();
      
    } 

  }

  checkPublishStatus(){
    const currentParams = { ...this.route.snapshot.queryParams };
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(
      APIConfigMapping["ENABLE_PUBLISH"]
    );
    apiConfig.postData = {"application_id":currentParams['id']};

    this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$)).subscribe({
      next: (data: any) => {
        this.publishStatus = data;
        this.spinnerActive=false;
      },
      error: (err: any) => {
        if(err?.status == 403) {
          this.toasterService.error('You do not have permission to access this resource.');
        }
        this.spinnerActive=false;
      },
    });
  }

  openModal(template:TemplateRef<any>): void {
    const dialogRef = this.dialog.open(template, {
      disableClose: true,
      width:"600px"
    });
  
  }

  publish(template:TemplateRef<any>) {
    if(!(!this.publishStatus || this.isPublished || this.fetchingAPKDetails)){
    this.openModal(template);
    }
  }

  closeTemplate(): void {
    this.dialog.closeAll();
  }

  publishApiCall(){
    this.closeTemplate();
    this.fetchingAPKDetails = true;
    this.downLoadURL = '';
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(
      APIConfigMapping["PUBLISH_APP"]
    );
    apiConfig.postData = {"application_id":this.queryParams['id']};
    this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$)).subscribe({
      next: (data: any) => {
        this.toasterService.success('Published !!');
      },
      complete: () => {
        this.dialog.closeAll();
        let apkDetails =  this.applicationDetails.value;
        // this.triggerGitHubEventLocally();
        if(this.versionList && this.versionList.length > 0  && this.versionList[this.versionList.length - 1].createdDate  === apkDetails.lastModified ){
          this.addApkDetails("true",apkDetails,this.certificateDetails.value);
       }else{
         this.addApkDetails("false",apkDetails,this.certificateDetails.value);
       }
     
      },
      error: (err: any) => {
        if(err?.status == 403) {
          this.toasterService.error('You do not have permission to access this resource.');
        }
      },
    });
  }

  triggerGitHubEventLocally(): void{

    const apiUrl = this.environment.URL_MAPPING.GITHUB_APIURL;
    const githubToken = this.environment.URL_MAPPING.GITHUB_TOKEN;
    const customerData = JSON.parse(localStorage.getItem('customerInfo') as string);
    const projectData = JSON.parse(localStorage.getItem('ProjectMetaData') as string);
    let appDetails = this.applicationDetails.value;
    if(this.flutterConfig && this.flutterConfig.version_code){
      this.flutterConfig.version_code = parseInt(this.flutterConfig.version_code) + 1
    }else{
      this.flutterConfig  = {
        version_code : 1,
        appDetails : {
          "app_icon_url": this.mobileApplicationData?.image ? this.mobileApplicationData.image : this.environment.URL_MAPPING.UNIAPP_ICONRUL,
          "name":appDetails ? appDetails.applicationName : 'Vassar',
          "applicationVersion":appDetails.applicationVersion,
          "playstoreApplicationId": this.applicationDetails.get("playstoreApplicationId")?.value,
        }
      }
    }
    if(this.versionList.length == 0){
      this.flutterConfig.appDetails['certificateDetails'] = this.certificateDetails.value;
    }else if(this.flutterConfig.appDetails){
      this.flutterConfig.appDetails.lastModified = this.versionList[this.versionList.length - 1].createdDate;
    }
    this.flutterConfig['appDetails'] = JSON.stringify(this.flutterConfig['appDetails']);
    console.log(this.flutterConfig);
    const body : any = {
      "event_type": "trigger-signed-apk-event",
      "client_payload": {
        "project_Id":projectData.project_id,
        "customer_Id":customerData?.customerId,
        "app_id": this.queryParams['id'],
         "keystore_url": this.environment.URL_MAPPING.KEYSTORE_URL,
        "env": this.environment.ENV,
        "apk_api_url" : this.environment.URL_MAPPING.PROJ_API + 'applicationURL/create',
        appDetails : {
          "app_icon_url": this.mobileApplicationData?.image ? this.mobileApplicationData.image : this.environment.URL_MAPPING.UNIAPP_ICONRUL,
          "name":appDetails ? appDetails.applicationName : 'Vassar',
          applicationVersion:appDetails.applicationVersion,
          playstoreApplicationId: this.applicationDetails.get("playstoreApplicationId")?.value,
        },
        "flutter_config":this.flutterConfig,
      },
    };
     if(this.versionList.length === 0){
      body.client_payload["apkAndCertificateDetails"] = this.certificateDetails.value;
      }
    fetch(apiUrl, {method:'POST',body:JSON.stringify(body),headers:{
      'Accept': 'application/vnd.github+json',
      'Authorization': `Bearer ${githubToken}`
    }})
    .then((response) => {
      this.startFetchingAPKDetails();
    },(error) => {
      if(error?.status == 403) {
        this.toasterService.error('You do not have permission to access this resource.');
      }
    })
    this.isPublished = true;
  }
  
  downloadAPK(url: string) {
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', url);
    link.setAttribute('download', '');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  
  copyToClipboard(downLoadURL: string) {
    this.clipboard.copy(downLoadURL);
  }

  startFetchingAPKDetails() {
    try {
      this.fetchingAPKDetails = true;
      this.publishService.startApiCalls().pipe(takeUntil(this.destroy$)).subscribe({
        next: (res: any) => {
          if (res?.data && !res?.data?.is_published) {
            this.apkStatus = res?.data?.apk_status;
            this.fetchingAPKDetails = false;
            this.downLoadURL = res?.data?.apk_url ?? '';
            this.errorMessage = this.statusMessage[this.apkStatus];
            if(this.apkStatus === 'created'){
              let apkstring = res?.data?.flutter_config?.appDetails;
              let apkDetails = JSON.parse(apkstring);
              if(this.versionList && this.versionList.length > 0  && this.versionList[this.versionList.length - 1].createdDate  === apkDetails.lastModified ){
               this.addApkDetails("true",apkDetails,this.certificateDetails.value);
            }else{
              let certificateDetails = apkDetails.certificateDetails;
              apkDetails = delete apkDetails.certificateDetails;
              this.addApkDetails("false",apkDetails,certificateDetails);
            }
          }
            this.publishService.stopApiCalls(res?.data);
          }
          else {
            this.downLoadURL = "";
            this.fetchingAPKDetails = true;
          }
        },
        complete: () => {
          this.fetchingAPKDetails = false;
        },
        error: (error:any) => {
          if(error?.status == 403) {
            this.toasterService.error('You do not have permission to access this resource.');
          }else{
            this.toasterService.error("Error while fetching APK details!!")
          }
            this.fetchingAPKDetails = false;
            this.publishService.stopApiCalls({})
        }
      })
    }
    catch(err) {
      console.error('Error occured:', err);
    }
  }

  ngOnDestroy() {
    this.subscriptions?.forEach((sub: any) => {
      if(sub && !this.fetchingAPKDetails) {
        sub.complete();
        sub.unsubscribe();
      }
    })
    this.destroy$.next();
    this.destroy$.complete();
  }


  // new publish implement

  onfileChange(event:any){
    const selectedFile = event.target.files[0];
  
    if (selectedFile) {
      this.openCropper(selectedFile);
    }
  }

  getDefaultAppLogo(imageUrl:string): Promise<File> {
    const defaultAppLogoUrl = this.imageSrc;
    return new Promise((resolve, reject) => {
      this.http.get(imageUrl, { responseType: "blob" }).pipe(takeUntil(this.destroy$)).subscribe(
        (data: Blob) => {
          const fileName = "defaultAppLogo.png";
          const fileType = "image/png";
          const lastModified = Date.now();
          const defaultImageFile = new File([data], fileName, {
            type: fileType,
            lastModified: lastModified,
          });
          // this.defaultAppLolo = defaultImageFile;
          resolve(defaultImageFile);
        },
        (error) => {
          if(error?.status == 403) {
            this.toasterService.error('You do not have permission to access this resource.');
          }
          console.error("Failed to fetch the default image: ", error);
          reject(error);
        }
      );
    });
  }

  openCropper(selectedimage:File){
    const dialogRef =  this.dialog.open(ImageCropperComponent,{
       disableClose: true,
       data: {
        imageFile:selectedimage
      }
    })

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {

      if (typeof (result) !== 'boolean' && result !== undefined) {
        
        this.imageSrc = result.croppedImageUrl;
        this.applicationDetails.patchValue({
          image: result.croppedImageFile
        }) 
      }
    });
  }

  addApkDetails(isUpdate:string,appDetails:any,certificateDetails?:any){
    let postData = {
      applicationId: "",
      ...appDetails,
      ...certificateDetails,
    }
    if (this.versionList && this.versionList.length > 0) {
      postData.isUpdate = isUpdate;
      postData.playstoreApplicationId = this.applicationDetails.get("playstoreApplicationId")?.value;
      postData.image = this.applicationDetails.get("image")?.value;
    }
    this.publishService.addCertificateDetails(postData).pipe(takeUntil(this.destroy$)).subscribe({
      next: (data: any) => {
        this.versionList = [data,...this.versionList]
      },
      error: (err: any) => {
        if(err?.status == 403) {
          this.toasterService.error('You do not have permission to access this resource.');
        }else{
          this.toasterService.error("Error while adding APK details!!")
        }
      }
    });
  }

  saveApkDetails(stepper:MatStepper){
    if(stepper.selectedIndex === 0){
      stepper.next();
    }else{
      if(this.applicationDetails.valid && (this.versionList && this.versionList.length > 0 || this.certificateDetails.valid)){
        this.showDetails = true;
        this.dialog.closeAll();
      }
    }
  }

}
